export const POSITION = [
  { value: 'topLeft', label: 'Top Left' },
  { value: 'topCenter', label: 'Top Center' },
  { value: 'topRight', label: 'Top Right' },
  { value: 'middleLeft', label: 'Middle Left' },
  { value: 'middleCenter', label: 'Middle Center' },
  { value: 'middleRight', label: 'Middle Right' },
  { value: 'bottomLeft', label: 'Bottom Left' },
  { value: 'bottomCenter', label: 'Bottom Center' },
  { value: 'bottomRight', label: 'Bottom Right' },
];

export const POSITION_DETAIL = {
  topLeft: {
    content: 'start',
    align: 'start',
    class: 'justify-start items-start',
  },
  topCenter: {
    content: 'center',
    align: 'start',
    class: 'justify-center items-start',
  },
  topRight: {
    content: 'end',
    align: 'start',
    class: 'justify-end items-start',
  },
  middleLeft: {
    content: 'start',
    align: 'center',
    class: 'justify-start items-center',
  },
  middleCenter: {
    content: 'center',
    align: 'center',
    class: 'justify-center items-center',
  },
  middleRight: {
    content: 'end',
    align: 'center',
    class: 'justify-end items-center',
  },
  bottomLeft: {
    content: 'start',
    align: 'end',
    class: 'justify-start items-end',
  },
  bottomCenter: {
    content: 'center',
    align: 'end',
    class: 'justify-center items-end',
  },
  bottomRight: { content: 'end', align: 'end', class: 'justify-end items-end' },
} as any;

export const FLEX_ALIGN = {
  left: 'flex start',
  center: 'center',
  right: 'flex-end',
};
